/* global APP */
/**
 * Provide async and deferred load support to the script. 
 */
var onloadAlreadyRun = false;
var onloadEventFired = false;

function entryPoint(e){
  onloadAlreadyRun=true;

  APP.init();
}

document.addEventListener('DOMContentLoaded', function(e){
  onloadEventFired=true;
  if (!onloadAlreadyRun){
    entryPoint(e);
  }
});

if (!onloadAlreadyRun && !onloadEventFired){
  entryPoint();
}